export default __webpack_public_path__ + "static/marketing-8234a408cdf5adf046b99bf2cfca2886.svg";